/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Simplified)
export default {
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright': '由 Atlassian Intelligence 提供支持',
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort': '由 Atlassian Intelligence 提供支持',
  'fabric.editor.ai.commandPalette.footer.disclaimerText': '内容取决于您的权限，且其质量可能会各不相同',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextShort': '内容质量可能有所不同',
  'fabric.editor.ai.commandPalette.footer.infoIconLabel': '信息',
  'fabric.editor.ai.commandPalette.footer.rovoCopyright': 'Rovo',
  'fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel': '包括来自当前页面的知识',
  'fabric.editor.ai.commandPalette.promptForm.logo': 'Atlassian Intelligence 徽标',
  'fabric.editor.ai.components.backIconButton.backLabel': '返回',
  'fabric.editor.ai.components.cancelEscButton.cancelLabel': '取消',
  'fabric.editor.ai.components.cancelEscButton.escLabel': 'Esc',
  'fabric.editor.ai.components.cancelIconButton.cancelLabel': '取消',
  'fabric.editor.ai.components.cancelIconButton.cancelTooltip': '取消',
  'fabric.editor.ai.components.feedbackForm.badResponse': '错误回复',
  'fabric.editor.ai.components.feedbackForm.feedbackSent': '已发送反馈',
  'fabric.editor.ai.components.feedbackForm.goodResponse': '良好回复',
  'fabric.editor.ai.config.item.action.continueFromLatestResponse': '从上次回复处继续',
  'fabric.editor.ai.config.item.action.copyResponse': '复制',
  'fabric.editor.ai.config.item.action.responseCopied': '已复制！',
  'fabric.editor.ai.config.item.action.responseCopiedToClipboard': '已复制到剪贴板',
  'fabric.editor.ai.config.item.action.retryPrompt': '重试',
  'fabric.editor.ai.experience-application.documentInsertError': '插入回复时出现问题。请关闭该对话框，然后重试。',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    '无法获取回复。您的提示或回复已超出针对此请求的限制。请关闭该对话框，然后重试。',
  'fabric.editor.ai.experience.apiError': '无法获取回复，请重试。',
  'fabric.editor.ai.experience.commandPaletteAriaName': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.inputTooShortError': '内容太短，无法总结。请添加更多内容，然后重试。',
  'fabric.editor.ai.experience.loadingAriaTitle': '正在生成',
  'fabric.editor.ai.experience.previewScreenLabel': '预览',
  'fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder': '让支持人员编写任意内容，或从下方进行选择',
  'fabric.editor.ai.experience.rovoAgents.productLabel': 'Rovo',
  'fabric.editor.ai.experience.rovoAgents.productLogoAltText': 'Rovo 徽标',
  'fabric.editor.ai.screens.UserInputCommamdPalette.footerText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.discard.cancelLabel': '返回',
  'fabric.editor.ai.screens.discard.discardLabel': '放弃',
  'fabric.editor.ai.screens.error.warningIconLabel': '警告',
  'fabric.editor.ai.screens.error.ariaErrorTitle': '错误',
  'fabric.editor.ai.screens.error.cancelLabel': '取消',
  'fabric.editor.ai.screens.error.retryLabel': '重试',
  'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription': '实时更新内容：',
  'fabric.editor.ai.screens.loading.iconAltText': '正在生成图标',
  'fabric.editor.ai.screens.preview.betaLabel': '测试版',
  'fabric.editor.ai.screens.preview.cancelLabel': '取消',
  'fabric.editor.ai.screens.preview.defaultAIPlaceholder': '告诉 AI 接下来要做什么',
  'fabric.editor.ai.screens.preview.discardLabel': '放弃',
  'fabric.editor.ai.screens.preview.disclaimer': '信息质量可能有所不同。',
  'fabric.editor.ai.screens.preview.disclaimerLink': '了解原因',
  'fabric.editor.ai.screens.preview.header.clear.hover': '清除',
  'fabric.editor.ai.screens.preview.header.edit': '编辑提示',
  'fabric.editor.ai.screens.preview.header.edit.hover': '编辑',
  'fabric.editor.ai.screens.preview.placeholderWithAgent': '询问 {agentName} 接下来要做什么',
  'fabric.editor.ai.screens.preview.refineButton': '完善',
  'fabric.editor.ai.screens.preview.refineDropdown.refineButton': '完善',
  'fabric.editor.ai.screens.prompt.logoAltText': 'Atlassian Intelligence 徽标',
  'fabric.editor.ai.screens.prompt.logoText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.prompt.submitLabel': '提交',
  'fabric.editor.ai.screens.prompt.submitTooltip': '发送给 Atlassian Intelligence',
  'fabric.editor.ai.screens.promptWithSelectedOption.promptSelected': '{promptName} - 已选择',
  'fabric.editor.ai.screens.promptWithSelectedOption.removeLabel': '移除',
  'fabric.editor.ai.shared.aiProactiveButtonLabel': '建议',
  'fabric.editor.ai.shared.aiUniversalDescriptor': '写作助手',
  'fabric.editor.ai.shared.aiUniversalLongCallToAction': '让 Atlassian Intelligence 协助您进行写作',
  'fabric.editor.ai.shared.aiUniversalShortCallToAction': '编写',
  'fabric.editor.ai.shared.betaLabel': '测试版',
  'fabric.editor.ai.shared.generateContent.aiButtonTitle': 'AI (Atlassian Intelligence)',
  'fabric.editor.ai.ui.components.suggestions.betaLozenge': '测试版',
  'fabric.editor.ai.ui.components.suggestions.newLozenge': '全新',
  'fabric.editor.ai.ui.components.suggestions.tellAILabel': '对 AI 说',
  'fabric.editor.ai.ui.components.suggestions.tellAgentLabel': '告诉支持人员',
};
